import React, { Component } from 'react';

const WithValidation = (WrappedComponent, validator) =>
  class extends Component {
    constructor(props) {
      super(props);
      this.jumpToProblems = this.jumpToProblems.bind(this);
      this.hasInvalidField = this.hasInvalidField.bind(this);
      this.state = { showProblems: false, invalidFields: [], isValid: true };
    }

    static getDerivedStateFromProps(nextProps) {
      return validator(nextProps);
    }

    componentDidMount() {
      this.setState(validator(this.props));
    }

    hasInvalidField(fieldId) {
      return this.state.invalidFields.includes(fieldId);
    }

    jumpToProblems(event, callback) {
      event.preventDefault();
      if (this.state.invalidFields && this.state.invalidFields.length > 0) {
        if (callback) {
          callback(event, this.state.invalidFields);
        } else {
          const field = document.getElementById(`${this.state.invalidFields[0]}_heading`)
            || document.getElementById(this.state.invalidFields[0]);
          if (field) {
            field.scrollIntoView();
          }
        }
      }
      this.setState({ showProblems: true });
    }

    render() {
      return (
        <WrappedComponent
          isValid={this.state.isValid}
          showProblems={this.state.showProblems}
          hasInvalidField={this.hasInvalidField}
          jumpToProblems={this.jumpToProblems}
          {...this.props}
        />
      );
    }
  };

export default WithValidation;
